import { Link } from 'react-router';
import { CONTACT } from '../../content/site';
import '../LandingPage.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">
          <Link to="/" className="footer-logo">
            EF<span>Soft</span>
          </Link>
          <p className="footer-tagline">
            Web applications for businesses, from the team that builds and runs
            ChatServe.
          </p>
        </div>

        <div className="footer-nav">
          <nav className="footer-col" aria-labelledby="footer-company">
            <p id="footer-company" className="footer-heading">Company</p>
            <Link to="/#services">Services</Link>
            <Link to="/#about">About</Link>
            <Link to="/#faq">FAQ</Link>
            <Link to="/products">Products</Link>
          </nav>
          <nav className="footer-col" aria-labelledby="footer-legal">
            <p id="footer-legal" className="footer-heading">Legal</p>
            <Link to="/privacy-policy">Privacy policy</Link>
            <Link to="/terms-of-service">Terms of service</Link>
            <Link to="/data-deletion">Data deletion</Link>
          </nav>
          <div className="footer-col">
            <p className="footer-heading">Contact</p>
            <a href={CONTACT.phoneHref}>{CONTACT.phoneDisplay}</a>
            <a href={CONTACT.emailHref}>{CONTACT.email}</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} EFSoft. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
